import { useEffect } from 'react';
import { FaPlug, FaServer } from 'react-icons/fa';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import Alert from '../../../Components/Alert';
import useUpdateApiConnection from '../../../Hooks/Services/useUpdateApiConnection';
import Loading from '../../../Components/Loading';

const UpdateApiConnection = ({ connection, onSuccess }) => {
    const { values, errors, error, success, isLoading, handleChange, handleSubmit, setValues } = useUpdateApiConnection(connection.id, { onSuccess });

    useEffect(() => {
        if (connection) {
            setValues({
                provider: connection.provider || '',
                status: connection.status || 'active'
            });
        }
    }, [connection, setValues]);

    return (
        <div className="p-6">
            <div className="max-w-md mx-auto">
                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-main1/10 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FaPlug className="text-3xl text-main1" />
                    </div>
                    <h3 className="text-xl font-bold text-main1 mb-2">تحديث اتصال API</h3>
                    <p className="text-sm text-gray-600">تحديث معلومات اتصال {connection?.service}</p>
                </div>

                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div>
                        <InputField
                            className="p-3"
                            placeholder="مزود الخدمة"
                            Icon={FaServer}
                            type="text"
                            name="provider"
                            value={values.provider}
                            onChange={handleChange}
                            error={errors.provider}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-main1 mb-2">الحالة</label>
                        <select
                            name="status"
                            value={values.status}
                            onChange={handleChange}
                            className="w-full p-3 rounded-3xl border border-gray-200 bg-grayish text-main1 focus:outline-none focus:ring-1 focus:ring-main1 font-cairo"
                        >
                            <option value="active">نشط</option>
                            <option value="inactive">غير نشط</option>
                        </select>
                    </div>

                    <Button 
                        type="submit" 
                        className="mt-6"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex items-center gap-3 m-1">
                                <Loading type="dots" size="md" text="جاري التحديث ..." color="light" />
                            </div>
                        ) : (
                            'تحديث الاتصال'
                        )}
                    </Button>
                </form>

                {error && <Alert type="error">{error}</Alert>}
                {success && <Alert type="success">{success}</Alert>}
            </div>
        </div>
    );
};

export default UpdateApiConnection;
